import React, { useState, FormEvent } from 'react';
// @ts-ignore
import CompanyLogo from '../../assets/company-logo.png';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../../firebase';
import Version from '../../version';

interface ForgotPasswordProps {
  close: () => void;
  email?: string;
}

const ForgotPassword: React.FC<ForgotPasswordProps> = ({
  close,
  email = ''
}) => {
  const [recoverError, setRecoverError] = useState<Error | null>(null);
  const [showSuccess, setShowSuccess] = useState<boolean>(false);
  const [inputEmail, setInputEmail] = useState<string>(email);

  const recover = async (e: FormEvent) => {
    e.preventDefault();
    try {
      await sendPasswordResetEmail(auth, inputEmail);
      setShowSuccess(true);
      setRecoverError(null);
    } catch (error) {
      setRecoverError(error);
    }
  };

  return (
    <div className="min-h-full flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <img
          className="mx-auto h-12 w-auto mb-6"
          src={CompanyLogo}
          alt="Company Logo"
        />
        <h2 className="mt-8 text-center text-3xl font-extrabold text-gray-900">
          Reset Your Password
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600">
          We will email you a password reset link if your email is registered
          with us.
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          {recoverError && (
            <div className="text-red-700 mb-2">{recoverError.message}</div>
          )}
          {showSuccess ? (
            <div>
              <div className="text-green text-sm text-center mb-4">
                Please check your email and your Spam folder.
              </div>
              <div className="mt-2">
                <button
                  type="button"
                  onClick={close}
                  className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-button-text bg-button-bg hover:bg-button-bg-hover hover:text-button-text-hover focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                  Back to Login
                </button>
              </div>
            </div>
          ) : (
            <form className="space-y-6" onSubmit={recover}>
              <div>
                <label
                  htmlFor="email"
                  className="block text-sm font-medium text-gray-700">
                  Email address
                </label>
                <div className="mt-1">
                  <input
                    id="email"
                    name="email"
                    type="email"
                    value={inputEmail}
                    onChange={e => setInputEmail(e.target.value)}
                    autoComplete="email"
                    required
                    className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                  />
                </div>
              </div>

              <div className="text-sm">
                <a
                  href="#"
                  onClick={e => {
                    e.preventDefault();
                    close();
                  }}
                  className="font-medium text-activecourse-blue hover:text-activecourse-orange">
                  Back to Login?
                </a>
              </div>

              <div>
                <button
                  type="submit"
                  className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-button-text bg-button-bg hover:bg-button-bg-hover hover:text-button-text-hover focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                  Send Password Reset Email
                </button>
              </div>
            </form>
          )}
          <Version />
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
